<template>
  <v-row justify="center">
    <v-dialog
      class="weekNoForceFullPopup"
      v-model="dialogFlag"
      persistent
      max-width="500"
    >
      <v-card>
          <v-toolbar dense elevation="0" dark color="accent">
            <v-toolbar-title>Next Week Update For Parents</v-toolbar-title>
          </v-toolbar>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col
                  cols="12"
                  md="12"
                  lg="12"
                  sm="12"
                  xs="12"
              >
                <v-card-title class="subtitle-1 px-0 font-weight-medium">
                  Please provide the week number you plan to teach next week.
                </v-card-title>
                <v-autocomplete
                  class="my-0 py-1"
                  v-model="selectedWeekID"
                  :items="weekList"
                  key="id"
                  item-value="id"
                  item-text="weekName"
                  label="Select Week"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-card-actions class="d-flex justify-center">
              <v-btn
                color="accent"
                width="200"
                outlined
                @click="saveWeekNo"
              >
                <v-icon small>mdi-content-save</v-icon> <span class="ml-1">Save</span>
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import Utils from '@/utils'
import moment from 'moment'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import stores from '@/stores'
export default {
  data () {
    return {
      franchiseeID: null,
      academicYearID: null,
      dialogFlag: false,
      selectedWeekID: 1,
      validateWeekField: false,
      weekList: [],
      isLastWeekApiSuccess: false
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: {
      handler: function (newVal) {
        this.franchiseeID = newVal.id
        if (!newVal.id && !this.academicYear.id) {
          Utils.helper.openDrawer(this)
        } else if (!newVal.id && this.academicYear.id) {
          Utils.helper.openDrawer(this)
        } else if (newVal.id && this.academicYear.id) {
          this.franchiseeID = newVal.id
          Utils.helper.openDrawer(this, false)
          let cookieName = stores.user.me.id + '_thr_popup'
          let getCookieByName = this.getCookie(cookieName)
          if (!this.isLastWeekApiSuccess && !getCookieByName) {
            this.getLastSelectedWeekId()
            this.dialogFlag = true
          }
        }
      },
      deep: true
    },
    academicYear: {
      handler: function (newVal) {
        this.academicYearID = newVal.id
        if (!newVal.id && !this.franchisee.id) {
          Utils.helper.openDrawer(this)
        } else if (!newVal.id && this.franchisee.id) {
          Utils.helper.openDrawer(this)
        } else if (newVal.id && this.franchisee.id) {
          this.academicYearID = newVal.id
          Utils.helper.openDrawer(this, 'close')
          let cookieName = stores.user.me.id + '_thr_popup'
          let getCookieByName = this.getCookie(cookieName)
          if (!this.isLastWeekApiSuccess && !getCookieByName) {
            this.getLastSelectedWeekId()
            this.dialogFlag = true
          }
        }
      },
      deep: true
    },
    '$store.state.isRightDrawer': function (newVal) {
      if (!newVal) {
        if (!this.franchiseeID || !this.academicYearID) {
          Utils.helper.openDrawer(this)
        }
      }
    }
  },
  created () {
    let cookieName = stores.user.me.id + '_thr_popup'
    let getCookieByName = this.getCookie(cookieName)
    if (this.academicYear && this.academicYear.id) {
      this.academicYearID = this.academicYear.id
    }
    if (this.franchisee && this.franchisee.id) {
      this.franchiseeID = this.franchisee.id
    }
    if (!this.academicYearID) {
      Utils.helper.openDrawer(this)
    }
    // let today = new Date()
    // let dayOfWeek = today.getDay()
    // if (getCookieByName == null && (dayOfWeek >= 4 && dayOfWeek < 6)) {
    if (getCookieByName == null) {
      this.getWeekList()
      if (this.academicYearID && this.franchiseeID) {
        if (!this.isLastWeekApiSuccess) {
          this.getLastSelectedWeekId()
          this.dialogFlag = true
        }
      }
    } else {
      this.dialogFlag = false
    }
  },
  methods: {
    getNextThursday: function () {
      let showPopupOnDayNumber = 4 // Thursday
      let today = new Date()
      let dayOfWeek = today.getDay()
      if (dayOfWeek === showPopupOnDayNumber) {
        // If today is Thursday, add 7 days to get the next Thursday
        today.setDate(today.getDate() + 7)
      } else {
        // Calculate days until next Thursday
        let daysUntilThursday = (dayOfWeek < showPopupOnDayNumber) ? (showPopupOnDayNumber - dayOfWeek) : (11 - dayOfWeek)
        today.setDate(today.getDate() + daysUntilThursday)
      }
      // Set time to start of the day
      today.setHours(0, 0, 0, 0)
      return today
    },
    setCookie (name, value, expiryDate) {
      document.cookie = name + '=' + value + '; expires=' + expiryDate + '; path=/'
    },
    closeDialog: function () {
      this.dialogFlag = false
    },
    getCookie (cookieName) {
      let name = cookieName + '='
      let decodedCookie = decodeURIComponent(document.cookie)
      let cookieArray = decodedCookie.split(';')
      for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i]
        while (cookie.charAt(0) === ' ') {
          cookie = cookie.substring(1)
        }
        if (cookie.indexOf(name) === 0) {
          return cookie.substring(name.length, cookie.length)
        }
      }
      return null
    },
    getWeekList: async function () {
      try {
        const { data } = await http.get(
          `${constants.API_URL}/api/curriculum_cms/week/get/all`
        )
        if (data) {
          this.weekList = data
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getLastSelectedWeekId: async function () {
      try {
        let payload = {}
        payload.franchiseeID = this.franchiseeID
        payload.academicYearID = this.academicYearID
        const res = await http.post(
          `${constants.API_URL}/api/v1/curriculum_cms/getPreviousWeekUpdate`,
          payload
        )
        if (res.status === 200) {
          this.isLastWeekApiSuccess = true
          this.selectedWeekID = res.data.weekID
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log(errorMessage)
      }
    },
    saveWeekNo: async function () {
      try {
        this.validateWeekField = false
        if (!this.weekNo) {
          this.validateWeekField = true
        }
        if (!this.franchiseeID) {
          return this.errMsg('Please select franchisee.')
        }
        if (!this.academicYearID) {
          return this.errMsg('Please select academic year')
        }
        let payload = {}
        payload.franchiseeID = this.franchiseeID
        payload.academicYearID = this.academicYearID
        payload.weekID = this.selectedWeekID
        let res = await http.post(
          `${constants.API_URL}/api/v1/curriculum_cms/weekUpdate`,
          payload
        )
        if (res.status === 200) {
          let cookieName = stores.user.me.id + '_thr_popup'
          this.setCookie(cookieName, this.selectedWeekID, moment(this.getNextThursday()).toString())
          this.okMsg(res.data.message)
          this.dialogFlag = false
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style>
.v-navigation-drawer--temporary{
  z-index:999999!important;
}
</style>
